import { render, staticRenderFns } from "./onaydialogchkbox.vue?vue&type=template&id=0dd055fd&"
import script from "./onaydialogchkbox.vue?vue&type=script&lang=js&"
export * from "./onaydialogchkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports